import * as React from 'react';
import { IconChevronDown } from '@tock/icons';
import { Select as MuiSelect } from '@mui/material';
import { SelectProps as MuiSelectProps } from '@mui/material/Select';
import { selectRoot } from './selectCssDefs';

export type SelectProps = MuiSelectProps;

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Select: React.FunctionComponent<React.PropsWithChildren<MuiSelectProps>> = ({
  fullWidth,
  variant = 'outlined',
  inputProps,
  name,
  id,
  ...rest
}) => {
  return (
    <MuiSelect
      inputProps={{
        style: {
          minWidth: fullWidth ? undefined : 'auto',
          width: fullWidth ? '100%' : 'auto',
        },
        name,
        id,
        ...inputProps,
      }}
      css={selectRoot}
      native
      IconComponent={IconChevronDown}
      variant={variant}
      {...rest}
    ></MuiSelect>
  );
};

export default Select;
